import React, { useState, useEffect, useRef } from "react";
import {
  Row,
  Col,
  Button,
  Input,
  Image,
  Divider,
  Table,
  Card,
  Spin,
  Badge,
  message,
  Typography,
  Tooltip,
  Modal,
  Space,
} from "../../../../components/common/utils/antd-imports/AntdImports.js";
import { useMediaQuery } from "react-responsive";
import "../../../../main.css";
import "../view-campaigns/ViewCampaigns.css";
import { ReactComponent as BackArrow } from "../../../../assests/back-arrow.svg";
import ShareCampaignIcon from "../../../../assests/share_icon.svg";
import ShareIcon from "./../../../../components/common/reusable-svg-icons/share-icon";
import { useDispatch, useSelector } from "react-redux";
import {
  getSellerCampaigns,
  sellerCampaignsCount,
} from "../../../../store/thunks/seller-thunks/SellerThunk.js";
import ShareCampaign from "../../../../components/modal/share-campaign-modal/ShareCampaign.js";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import Arrow3 from "../../../../assests/Arrow 3.svg";
import {
  formatDate,
  formatToUSCurrency,
  handleCopy,
} from "../../../../components/common/utils/Utils.js";
import EyeIcon from "../../../../components/common/reusable-svg-icons/eye-icon.js";
import { ReactComponent as SearchIcon } from "../../../../assests/search-icon.svg";
import EmptyViewCard from "../../../../components/common/empty-view-card/EmptyViewCard.js";
import BreadcrumbNav from "../../../../components/common/bread-crumbs/BreadCrumb.js";
import {
  addBreadcrumb,
  setBreadcrumbs,
} from "../../../../store/slices/common-slice/bread-crumbs/BreadCrumbSlice.js";
import { CopyOutlined } from "@ant-design/icons";
import { docuSignCallback } from "../../../../store/thunks/buyer-thunks/BuyerThunks.js";
const ViewCampaigns = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();

  const isMobile = useMediaQuery({ maxWidth: 768 });
  const isTablet = useMediaQuery({ maxWidth: 1024 });
  const [segmentValue, setSegmentValue] = useState(
    searchParams.get("segment") || "insertion_order",
  );
  const [shareCampaignModal, setShareCampaignModal] = useState(false);
  const campaignsCount = useRef();
  const [selectedId, setSelectedId] = useState(null);
  const { Text } = Typography;
  const goToSubPage = ({ title, path }) => {
    if (segmentValue === "insertion_order") {
      dispatch(
        setBreadcrumbs([
          { title: "Dashboard", path: "/seller/dashboard" },
          {
            title: "Campaigns",
            path: "/seller/viewCampaigns?segment=insertion_order",
          },
          {
            title: "Insertion Order",
            path: "/seller/viewCampaigns?segment=insertion_order",
          },
          { title, path },
        ]),
      );
    } else {
      dispatch(addBreadcrumb({ title, path }));
    }
  };

  const handleShareCampaign = (record) => {
    setShareCampaignModal(true);
    setSelectedId(record?.id);
  };
useEffect(() => {
  const handleSigningComplete = async () => {
    const params = new URLSearchParams(window.location.search);
    const event = params.get("event");

    if (event !== "signing_complete") {
      return;
    }

    const envelopeId = localStorage.getItem(
      "docusignCampaignEnvelopeId"
    );


    if (!envelopeId) {
      console.error("DocuSign envelope ID not found in localStorage");
      return;
    }

    try {
      const result = await dispatch(
        docuSignCallback(envelopeId)
      ).unwrap();


      if (result == 1) {
        localStorage.removeItem("docusignCampaignEnvelopeId");
        console.log("Envelope ID removed from localStorage");
      }
    } catch (error) {
      console.error("DocuSign callback API error:", error);
    }
  };

  handleSigningComplete();
}, [dispatch]);
  const TableWithCustomRender = ({ data }) => {
    const columns = [
      {
        title: "Campaign ID",
        dataIndex: "cid",
        render: (text, record) => (
          <div className="product-copy-text-field">
            <a
              className="campaign-link"
              onClick={(e) => {
                e.preventDefault();

                goToSubPage({
                  title: record.name,
                  path: `/seller/viewCampaigns/campaignDetails/${btoa(
                    record.id,
                  )}`,
                });
                navigate(
                  `/seller/viewCampaigns/campaignDetails/${btoa(record.id)}`,
                );
              }}
            >
              {text}
            </a>
            <CopyOutlined
              onClick={(e) => {
                e.stopPropagation(); // prevent tooltip close
                handleCopy(text);
              }}
              className="copy-icon"
            />
          </div>
        ),
        key: "cid",
        width: 250,
        align: "left",
        sorter: (a, b) => a.cid.localeCompare(b.cid),
      },
      {
        title: "Campaign Name",
        dataIndex: "name",
        key: "name",
        align: "left",
        sorter: (a, b) => a.name.localeCompare(b.name),
        width: isTablet ? 150 : 190,
        render: (text, record) => (
          <div className="product-copy-text-field">
            <Tooltip title={text}>
              <Text className="card-campaign-text truncate">{text}</Text>
            </Tooltip>
            <CopyOutlined
              onClick={(e) => {
                e.stopPropagation(); // prevent tooltip close
                handleCopy(record?.name);
              }}
              className="copy-icon"
            />
          </div>
        ),
      },
      {
        title: "Start Date",
        dataIndex: "start_date",
        key: "start_date",
        align: "left",
        sorter: (a, b) => new Date(a.start_date) - new Date(b.start_date),
        width: 137,
        render: (value) => {
          // Format date to only display the date
          const formattedDate = new Date(value).toLocaleDateString("en-US", {
            day: "numeric",
            month: "short",
            year: "numeric",
          });
          return <span>{formattedDate}</span>;
        },
      },
      {
        title: "End Date",
        dataIndex: "end_date",
        key: "end_date",
        sorter: (a, b) => new Date(a.end_date) - new Date(b.end_date),
        width: 160,
        align: "left",
        render: (value) => {
          // Format date to only display the date
          const formattedDate = new Date(value).toLocaleDateString("en-US", {
            month: "short",
            day: "numeric",
            year: "numeric",
          });
          return <span>{formattedDate}</span>;
        },
      },
      {
        title: "Price",
        dataIndex: "total_price",
        key: "total_price",
        sorter: (a, b) => a.total_price - b.total_price,
        width: 99,
        align: "right",
        render: (value) => (value ? formatToUSCurrency(value.toFixed(2)) : ""),
      },
      {
        title: "No. of Products",
        dataIndex: "no_products",
        key: "no_products",
        sorter: (a, b) => a.no_products - b.no_products,
        width: 180,
        align: "center",
      },
      {
        title: <div style={{ textAlign: "center" }}>Actions</div>,
        dataIndex: "action",
        key: "action",
        width: 170,
        render: (_, record) => (
          <div className="action-column">
            <Button
              style={{ border: "none" }}
              onClick={() => {
                goToSubPage({
                  title: record.name,
                  path: `/seller/viewCampaigns/campaignDetails/${btoa(
                    record.id,
                  )}`,
                });
                navigateCampaignDetails(record);
              }}
            >
              <EyeIcon
                width={20}
                height={20}
                color={"#D2042D"}
                textColor={"#D2042D"}
                Text={"View Details"}
                className="mobile-action-icons mobile-view-icon"
              />{" "}
            </Button>
            <Button
              className="popover-campaign"
              name="share-campaign"
              onClick={() => handleShareCampaign(record)}
            >
              <Image
                src={ShareCampaignIcon}
                alt="share-icon"
                preview={false}
                className="popover-icon share-icon"
              />
              <span className="popover-label">Share Campaign </span>
            </Button>
          </div>
        ),
      },
    ];
    return (
      <Table
        className="view-campaigns-table campaign-utility"
        columns={columns}
        width={"100%"}
        dataSource={data}
        rowClassName="custom-row"
        rowKey="id"
        pagination={{ position: ["bottomCenter"], pageSize: "8" }} // You can customize the position of the pagination
      />
    );
  };
  const navigateCampaignDetails = (record) => {
    navigate(`/seller/viewCampaigns/campaignDetails/${btoa(record?.id)}`);
  };
  const [searchText, setSearchText] = useState("");

  const {
    campaignsList,
    isLoading,
    isCampaignLoading,
    campaigns_running,
    campaigns_closed,
  } = useSelector((state) => state.sellerCampaigns);

  const [filteredList, setFilteredList] = useState(campaignsList);

  useEffect(() => {
    setFilteredList(campaignsList);
  }, [campaignsList]);

  const handleSegmentChange = (value) => {
    setSegmentValue(value);
    const userRole = sessionStorage.getItem("userRole");
    const dashboardPath =
      userRole === "owner" ? "/seller/dashboard" : "/buyer/dashboard";

    const campaignBreadcrumbMap = {
      insertion_order: "Insertion Order",
      scheduled: "Scheduled Campaigns",
      running: "Running Campaigns",
      closed: "Closed Campaigns",
    };

    dispatch(
      setBreadcrumbs([
        { title: "Dashboard", path: dashboardPath },
        {
          title: "Campaigns",
          path: `/seller/viewCampaigns?segment=insertion_order`,
        },
        {
          title: campaignBreadcrumbMap[value || "Insertion Order"],
          path: `/seller/viewCampaigns?segment=${value}`,
        },
      ]),
    );

    navigate(`/seller/viewCampaigns?segment=${value}`);

    dispatch(getSellerCampaigns(value));
    if (!isLoading) setFilteredList(campaignsList);
  };

  useEffect(() => {
    if (searchText === "") {
      return setFilteredList(campaignsList);
    } else {
      const filtered = campaignsList?.filter(
        (campaign) =>
          campaign.cid.toLowerCase().includes(searchText.toLowerCase()) ||
          campaign.name.toLowerCase().includes(searchText.toLowerCase()) ||
          campaign.start_date.includes(searchText.toLowerCase()) ||
          campaign.end_date.includes(searchText.toLowerCase()) ||
          campaign.total_price?.toString().includes(searchText.toLowerCase()) ||
          campaign.no_products?.toString().includes(searchText.toLowerCase()),
      );
      setFilteredList(filtered);
    }
  }, [searchText]);

  useEffect(() => {
    const segment = searchParams.get("segment");
    if (segment === "insertion_order") {
      dispatch(
        addBreadcrumb({
          title: "Insertion Order",
          path: "/seller/viewCampaigns?segment=insertion_order",
        }),
      );
    } else {
    }

    if (segment && segment !== segmentValue) {
      setSegmentValue(segment);
    }
    dispatch(getSellerCampaigns(segment));
  }, [searchParams]);

  useEffect(() => {
    dispatch(sellerCampaignsCount())
      .unwrap()
      .then((data) => {
        const {
          campaigns_io,
          campaigns_running,
          campaigns_sceduled,
          campaigns_closed,
        } = data;
        campaignsCount.campaigns_io = campaigns_io ? campaigns_io : 0;
        campaignsCount.campaigns_running = campaigns_running
          ? campaigns_running
          : 0;
        campaignsCount.campaigns_sceduled = campaigns_sceduled
          ? campaigns_sceduled
          : 0;
        campaignsCount.campaigns_closed = campaigns_closed
          ? campaigns_closed
          : 0;
        dispatch(getSellerCampaigns(segmentValue));
        if (!isLoading) setFilteredList(campaignsList);
      })
      .catch(() => {
        message.error("Something went wrong!");
      });
  }, [dispatch]);

  const tabs = [
    {
      name: "Insertion Order",
      count: campaignsCount.campaigns_io,
      value: "insertion_order",
    },
    {
      name: "Scheduled",
      count: campaignsCount.campaigns_sceduled,
      value: "scheduled",
    },
    {
      name: "Running",
      count: campaigns_running,
      value: "running",
    },
    {
      name: "Closed",
      count: campaigns_closed,
      value: "closed",
    },
  ];
  useEffect(() => {
  const params = new URLSearchParams(window.location.search);
  const event = params.get("event");
  if (event === "signing_complete") {
    message.success("Campaign has been signed successfully");
  }
}, []);
  return (
    <div className="common-container view-seller-campaigns">
      <Row className="view-campaigns-header">
        <Col span={isMobile ? 24 : isTablet ? 12 : 12}>
          <div className="bread-crumb-placement">
            <BreadcrumbNav />
          </div>
          <div className="seller-campaign-list">
            {/* <BackArrow className="arrow-align" onClick={() => navigate(-1)} /> */}
            <span className="main-title-size"> Campaigns</span>
          </div>
        </Col>
        {isMobile && (
          <div className="mobile-view-segmentss-tab">
            <div className="segment-sizes">
              {tabs?.map((tab) => (
                <div
                  key={tab.value}
                  className={
                    segmentValue === tab.value
                      ? "billboard-selected-segment"
                      : "billboard-non-selected-segment"
                  }
                  onClick={() => handleSegmentChange(tab.value)}
                >
                  <span className="set-width">{tab.name}</span>
                  <span className="billboards-count">{tab.count}</span>
                </div>
              ))}
            </div>
          </div>
        )}

        <Col span={isMobile ? 24 : isTablet ? 12 : 11} className="search-input">
          <Input
            allowClear
            prefix={<SearchIcon />}
            className="view-campaign-search common-search"
            value={searchText}
            onChange={(event) => setSearchText(event.target.value)}
            placeholder="Search by campaign name, id..."
          />
        </Col>
      </Row>

      {!isMobile && (
        <>
          <Divider className="no-margin" />
          <div className="segment-sizes">
            {tabs?.map((tab) => (
              <div
                key={tab.value}
                className={
                  segmentValue === tab.value
                    ? "billboard-selected-segment"
                    : "billboard-non-selected-segment"
                }
                onClick={() => handleSegmentChange(tab.value)}
              >
                <span className="set-width">{tab.name}</span>
                <span className="billboards-count">{tab.count}</span>
              </div>
            ))}
          </div>
        </>
      )}

      <div className="scroll-container">
        <>
          <span>
            {filteredList?.length > 0 || campaignsList?.length > 0 ? (
              <div className="view-campaign-table-container">
                {!isMobile ? (
                  <TableWithCustomRender
                    className="view-campaigns-table campaign-utility"
                    data={filteredList}
                  />
                ) : (
                  <>
                    <div className="seller-campaign-card-container">
                      {filteredList?.map((campaign) => {
                        return (
                          <Card
                            className="seller-campaign-cards"
                            key={campaign.cid}
                          >
                            <div className="campaign-detail-container-card">
                              <Row>
                                <Col span={18}>
                                  <label className="campaign-id campaign-id-sub-fields">
                                    {campaign.cid}
                                  </label>
                                  <br />
                                  <div>
                                    <label className="mobile-card-title-size">
                                      {campaign.name}
                                    </label>
                                    {campaign?.status == 1300 && (
                                      <Badge
                                        className="rfp-badge rfp-badge-css"
                                        count={"RFP"}
                                      />
                                    )}
                                  </div>
                                </Col>
                                <Col
                                  span={5}
                                  style={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                  }}
                                >
                                  <div className="total-price">
                                    {formatToUSCurrency(
                                      campaign?.total_price?.toFixed(2),
                                    )}
                                  </div>
                                </Col>
                              </Row>
                              <Row gutter={24}>
                                <Col>
                                  <div className="detail-label field-text-size">
                                    Start From
                                  </div>
                                  <label className="date-text-format">
                                    {" "}
                                    {formatDate(campaign.start_date)}
                                    <span>
                                      <Image
                                        src={Arrow3}
                                        className="detail-label-image"
                                        preview={false}
                                      />{" "}
                                    </span>
                                    {formatDate(campaign.end_date)}
                                  </label>
                                </Col>
                              </Row>
                              <Row>
                                <Col span={18}>
                                  <div className="detail-label field-text-size">
                                    No. of Products
                                  </div>
                                  <label className="field-text-size-label">
                                    {campaign?.no_products}
                                  </label>
                                </Col>
                                <Col span={6}>
                                  <div className="detail-label field-text-size">
                                    RFP Status
                                  </div>
                                  <label className="field-text-size-label">
                                    InProgress
                                  </label>
                                </Col>
                              </Row>
                              <Row>
                                <Col span={12}>
                                  <Button
                                    className="action-btn share-btn mobile-card-buttons"
                                    onClick={() => {
                                      setSelectedId(campaign.id);
                                      setShareCampaignModal(true);
                                    }}
                                  >
                                    <ShareIcon
                                      width={20}
                                      color={"#0A0F0D"}
                                      Text={"Share Campaign"}
                                      className="mobile-action-icons mobile-share-icon"
                                    />
                                  </Button>
                                </Col>
                                <Col span={12}>
                                  <Button
                                    className="view-btn mobile-card-buttons"
                                    onClick={() =>
                                      navigateCampaignDetails(campaign)
                                    }
                                  >
                                    <EyeIcon
                                      width={20}
                                      color={"#FCFCFC"}
                                      Text={"View Details"}
                                      className="mobile-action-icons mobile-view-icon"
                                    />
                                  </Button>
                                </Col>
                              </Row>
                            </div>
                          </Card>
                        );
                      })}
                    </div>
                  </>
                )}
                {shareCampaignModal && (
                  <Modal
                    open={shareCampaignModal}
                    footer={false}
                    width={558}
                    height={469}
                    closable={false}
                    centered
                  >
                    <ShareCampaign
                      shareCampaign={shareCampaignModal}
                      setShareCampaign={setShareCampaignModal}
                      campaignId={selectedId}
                    />
                  </Modal>
                )}
              </div>
            ) : (
              <Row className="empty-campaigns">
                <EmptyViewCard
                  header={"Campaigns"}
                  text={
                    "Looks like Buyers haven't added your products to any campaigns yet. Stay tuned- new opportunities could be just around the corner!"
                  }
                />
              </Row>
            )}
          </span>

          {(isLoading || isCampaignLoading) && (
            <div className="loading-css ">
              <Spin size="large" fullscreen />
            </div>
          )}
        </>
      </div>
    </div>
  );
};

export default ViewCampaigns;
